export const teacherDashboardEn = {
  // Teacher Dashboard specific
  teacherHome: 'Home',
  quranTracking: 'Quran Tracking',
  studentProgress: 'Student Progress',
  teacherMessages: 'Messages',
  teacherHomePage: 'Home Page',
  welcomeTeacher: 'Welcome Teacher',
  quranTrackingSubtitle: 'Tracking Quran memorization and review',
  totalStudents: 'Total Students',
  monthlyRecords: 'Monthly Records',
  averageGrade: 'Average Grade',
  unreadMessages: 'Unread Messages',
  quranTrackingTitle: 'Quran Memorization Tracking',
  allStudents: 'All Students',
  addNewRecord: 'Add New Record',
  noStudents: 'No students',
  noStudentsFilter: 'No students matching the filter',
  noRecords: 'No records available',
  studentProgressTitle: 'Student Progress in Quran Memorization',
  memorizationStats: 'Memorization Statistics',
  advancedStudents: 'Advanced Students (15+ Hizb)',
  intermediateStudents: 'Intermediate Students (5-14 Hizb)',
  beginnerStudents: 'Beginner Students (less than 5 Hizb)',
  messagesAndCommunication: 'Messages and Communication',
  addQuranRecord: 'Add Quran Record',
  editQuranRecord: 'Edit Quran Record',
  loadingStudents: 'Loading students list...',
  noStudentsAvailable: 'No students available',
  noStudentsRegistered: 'No students registered. Please contact the administrator.',
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  save: 'Save',
  confirmDelete: 'Are you sure you want to delete this record?',
  errorAddingRecord: 'Error adding record',
  errorDeletingRecord: 'Error deleting record',
  errorUpdatingData: 'Error updating data',
  sessionExistsToday: 'A session already exists for this student today, do you want to modify the existing session?',
  reportSent: 'Report sent successfully',
  errorSendingReport: 'Error sending report',
  quickReport: 'Quick Report',
  reportType: 'Report Type',
  reportMessage: 'Message',
  selectReportType: 'Select Report Type',
  backToHome: 'Back to Home Page',
  progressPercentage: 'Progress Percentage',
  hizbSaved: 'Hizb Memorized',
  forNextSession: 'For Next Session',
  previousSessions: 'Previous Sessions',
  
  // Messages (shared with parent)
  parentMessages: 'Parent Messages',
  noMessages: 'No messages',
  from: 'From:',
  
  // Message priorities
  priorityNormal: 'Normal',
  priorityHigh: 'High',
  priorityUrgent: 'Urgent',
  
  // Report types
  reportTypeAssignment: 'Homework',
  reportTypeProgress: 'Progress Report',
  reportTypeAchievement: 'Outstanding Achievement',
  reportTypeConcern: 'Important Note',
  
  // Sender types
  senderTeacher: 'Teacher',
  senderAdmin: 'Admin',
  senderParent: 'Parent',
  
  // Common
  dateUnknown: 'Not specified',
  update: 'Update',
  
  // Password change
  changePassword: 'Change Password',
  oldPassword: 'Old Password',
  newPassword: 'New Password',
  confirmPassword: 'Confirm Password',
  enterOldPassword: 'Enter old password',
  enterNewPassword: 'Enter new password',
  confirmNewPassword: 'Confirm new password',
  passwordChangedSuccess: 'Password changed successfully',
  errorChangingPassword: 'Error changing password',
  passwordTooShort: 'Password must be at least 6 characters',
  passwordMismatch: 'Passwords do not match',
  fillAllFields: 'Please fill all fields',
  changing: 'Changing...',
  student: 'Student',
  studentLabel: 'Student(s)',
  selectStudent: 'Select Student',
  sendButton: 'Send',
  messagePlaceholder: 'Write your message here...',
  
  // Teacher Dashboard specific stats labels
  presentToday: 'Present Today',
  absentToday: 'Absent Today',

  // New keys
  associationName: 'Al Falah Association',
  teacherBoardSubtitle: 'Teacher Dashboard',
  welcomeTeacherFemale: 'Welcome Teacher',
  welcomeTeacherMale: 'Welcome Teacher',
  examScoresTab: 'Exam Scores',
  replyToMessage: 'Reply to Message',
  to: 'To',
  allAdmins: 'All administrators',
  reportSentToAdmins: 'The report will be sent to all administrators',
  reportSentToAdminsAndParent: 'The report will be sent to all administrators and the selected student\'s parents',
  reportSentToStudentGuardians: 'The report will be sent to this student\'s parents',
  reportSentToAdminsAndGuardians: 'The report will be sent to all administrators and this student\'s parents',
  addExamScore: 'Add Exam Score',
  examDate: 'Exam Date',
  subjectLabel: 'Subject',
  gradeLabel: 'Grade (/20)',
  selectSubject: 'Select subject',
  notSpecified: 'Not specified',
  optional: '(optional)',
  noSentMessages: 'No sent messages',
  noReceivedMessages: 'No received messages',
  sentMessages: 'Sent Messages',
  receivedMessages: 'Received Messages',
  administration: 'Administration',

  // ExamScoresTable keys
  gradeOutOf20: 'Grade (/20)',
  date: 'Date',
  actions: 'Actions',
  noTestScores: 'No exam scores recorded',
  addTestScoreHint: 'Click "Add Exam Score" to add one',
  unknown: 'Unknown',

  // MessageItem keys
  noSubject: 'No subject',
  replyBadge: 'Reply',
  replyButton: 'Reply',

  // Alert messages
  noPermissionAdd: 'You do not have permission to add an exam score',
  fillRequiredFields: 'Please fill in all required fields',
  invalidGrade: 'Please enter a valid grade between 0 and 20',
  examScoreAdded: 'Exam score added successfully',
  examScoreAddFailed: 'Failed to add exam score',
  examScoreAddError: 'An error occurred while adding the exam score',
  noPermissionDelete: 'You do not have permission to delete an exam score',
  confirmDeleteScore: 'Are you sure you want to delete this exam score?',
  examScoreDeleted: 'Exam score deleted successfully',
  examScoreDeleteFailed: 'Failed to delete exam score',
  examScoreDeleteError: 'An error occurred while deleting the exam score',
  selectStudentOrAdmin: 'Please select a student or check Administration',
  selectStudentRequired: 'Please select a student',
  loadingDataError: 'Error loading data',

  // Quran tracking - previous sessions table columns
  quranTableDate: 'Date',
  quranTableNewHifz: 'New Hifz',
  quranTableOldMurajah: 'Old Murājaʿah',
  quranTableNewMurajah: 'New Murājaʿah',
  quranTableEvalNewHifz: 'Eval. Hifz',
  quranTableEvalOldMurajah: 'Eval. Old Murājaʿah',
  quranTableEvalNewMurajah: 'Eval. New Murājaʿah',
  quranTableNote: 'Note',
  quranTableHizb: 'No. Hizb',
  quranHizbLabel: 'hizb memorized',
  quranProgressLabel: 'Progress',
  quranProgressPercent: '% of Quran',
};

